import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { home } from './home.type';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private baseUrl: string;
  private _home: BehaviorSubject<home | null> = new BehaviorSubject(null);

  constructor(
    private httpClient: HttpClient,
  ) { 
    this.baseUrl = `${environment.apiURL}/home`
  }

  get home$(): Observable<home> {
    return this._home.asObservable();
  }

  detail() {
    const endpoint: string = this.baseUrl + '/statistics';
    return this.httpClient.get<home>(endpoint)
    .pipe(tap((res) => {
      this._home.next(res);
    }));;
  }
}
